import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import { animate } from 'animejs';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import './App.css';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function NavBar() {
  const location = useLocation();

  return (
    <nav className="navbar">
      <div className="nav-container">
        <ul className="nav-menu">
          <li className="nav-item">
            <span className="nav-divider">|</span>
            <Link to="/" className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}>Home</Link>
          </li>
          <li className="nav-item">
            <span className="nav-divider">|</span>
            <Link to="/about" className={`nav-link ${location.pathname === '/about' ? 'active' : ''}`}>About</Link>
            <span className="nav-divider">|</span>
          </li>
          <li className="nav-item">
            <a 
              href="https://drive.google.com/file/d/1v-Xkwh__pVaL4w6eTaa4866s34ae8rKo/view?usp=sharing" 
              className="nav-link"
              target="_blank" 
              rel="noopener noreferrer">
                CV
            </a>
            <span className="nav-divider">|</span>
          </li>
          <li className="nav-item nav-right">
            <span className="nav-divider">|</span>
            <Link to="/contact" className={`nav-link ${location.pathname === '/contact' ? 'active' : ''}`}>Contact</Link>
          </li>
          <li className="nav-item">
            <span className="nav-divider">|</span>
          </li>
        </ul>
      </div>
    </nav>
  );
}

function App() {
  useEffect(() => {
    // Fade in the navbar on initial load
    animate('.navbar', {
      opacity: [0, 1],
      duration: 800,
      easing: 'out-quad'
    });
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <NavBar />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
